/**
 * Right-aligned bubble for user-originated content (text notes + /ask).
 *
 * Painted in the Telegram "button" colour so it reads as the user's
 * voice without us picking a hard-coded brand colour. Bottom-right
 * corner is the tail; rounded less than the others.
 */
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  meta?: ReactNode;
}

export function UserBubble({ children, meta }: Props): React.ReactElement {
  return (
    <div className="flex flex-col items-end gap-0.5 px-3 py-0.5">
      <div
        className="max-w-[78%] rounded-[18px] rounded-br-[6px] px-3 py-1.5 text-[14px] leading-[19px] break-words"
        style={{
          background: "var(--color-button)",
          color: "var(--color-button-text)",
        }}
      >
        {children}
      </div>
      {meta ? (
        <div
          className="text-[10px] pr-1"
          style={{ color: "var(--color-hint)" }}
        >
          {meta}
        </div>
      ) : null}
    </div>
  );
}
